import { atom } from 'jotai';

export const allowStopAtom = atom(false);